import { Components, Theme } from '@mui/material';

export default function Autocomplete({ palette }: Theme): Components {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        groupLabel: {
          fontStyle: 'italic',
          color: palette.secondary.light,
        },
      },
    },
  };
}
